import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { restaurantSaveStoreAddons } from '../../../store/Restaurant/api';
import { toast } from 'react-toastify';


export const useEditStoreAddons = () => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    return useMutation(['editStoreAddons'], ({ id, params }) => restaurantSaveStoreAddons(id, params), {
        onError: (error) => {
            toast.error(error.response?.data?.message);
        },
    });
};
